import {AbstractMusicActivity} from "./AbstractMusicActivity";
import {MusicType} from "./MusicModel";
import {Bagpipes} from "./Bagpipes";
import {bagpipes} from "../../Layout/MusicScreenLayout";
import {AudioChannel} from "../../Core/AudioChannel";
import {Ease} from "../../Core/Animatable";
import {Keyboard} from "../Keyboard";
import {HomeScreen} from "../../States/HomeScreen";

const reactionVO = [
    "LetsGoLuna_202",
    "LetsGoLuna_203"
];

export class BagpipesActivity extends AbstractMusicActivity<Bagpipes> {

    readonly button: Bagpipes;

    constructor(screen: HomeScreen) {
        super(screen);

        this.button = this.sprite as any;
        this.button.enabled = false;

        bagpipes.call(this);
        this.sprite.saveTransform();

        let bgmVolume = 0;
        let isDown = false;
        const onUp = () => {
            if (isDown) {
                isDown = false;
                AudioChannel.SFX.stop(`${MusicType.Bagpipes}-start`);
                AudioChannel.SFX.stop(`${MusicType.Bagpipes}-loop`);
                AudioChannel.SFX.play(`${MusicType.Bagpipes}-end`);
                AudioChannel.BGM.volume = bgmVolume;
                this.button.enabled = true;
                this.button.killTweens();
                this.button.tweenTo(0.4, Ease.sineInOut, {inflation: 0});
                this.playReactionVO();
            }
            this.button.emitNotes(false);
        };

        this.button.onDown.add(() => {
            if (isDown) return;
            isDown = true;
            AudioChannel.SFX.play(`${MusicType.Bagpipes}-start`, () => {
                if (isDown) {
                    AudioChannel.SFX.play(`${MusicType.Bagpipes}-loop`, "loop");
                }
            });
            this.button.killTweens();
            this.button.tweenTo(2, Ease.sineInOut, {
                inflation: 1,
                onComplete: () => {
                    this.button.tweenTo(1, Ease.sineInOut, {
                        inflation: 0.7,
                        repeat: -1,
                        yoyo: true
                    });
                }
            });
            this.button.emitNotes(true);
            bgmVolume = AudioChannel.BGM.volume;
            AudioChannel.BGM.volume = 0;
        });
        this.button.onUp.add(onUp);
        this.button.onOut.add(onUp);
    }

    protected getMusicType(): MusicType {
        return MusicType.Bagpipes;
    }

    protected getSprite(): Bagpipes {
        return new Bagpipes();
    }

    protected activate() {
        super.activate();
        this.button.enabled = true;
        Keyboard.focus(this.button);
    }

    protected deactivate() {
        this.button.enabled = false;
        super.deactivate();
    }

    protected getReactionVO(): string[] | undefined {
        return reactionVO;
    }

    protected getFactVO(): string | undefined {
        return "LetsGoLuna_204";
    }
}